
import ThemeRoutes from "./routes";
import { ThemeProvider } from "@mui/material";
import theme from "./themes/theme";
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import Cookies from 'js-cookie';
import GoogleAnalytics from 'google-analytics';
// for latest version popup
import { FetchLatestVersion } from 'api/version';
import ReloadPopup from 'ui-components/ReloadPopup';
import EnvironmentIndicator from 'ui-components/EnvironmentIndicator';
import { ToastProvider } from 'context/ToastContext';
import { checkForDomain, setTokenForAuthorization } from './utilities';
import { capturePendingSubscriptionIntent } from './utilities/subscriptionIntent';
import 'utilities/mixpanel';
import NewFeaturesModal from "views/components/FeatureModal";
import 'assets/css/bootstrap.min.css';

function App() {

  const [params, setParams] = useSearchParams();

  useEffect(() => {
    // Capture any pending subscription intent before auth/onboarding state is computed.
    // This is the earliest point that runs regardless of auth state.
    capturePendingSubscriptionIntent();

    // console.log("App.js")
    if (params.get("token")?.length > 0) {
      if (params.get("token")) {
        setTokenForAuthorization(params.get("token"), checkForDomain())
      }
      if (params.get("is_profile_completed")) {
        Cookies.set("is_profile_complete", params.get("is_profile_completed"), { domain: checkForDomain() })
      }
      let currentUrl = window.location?.search
      let newUrl = window.location.href
      // console.log("currentUrl", currentUrl)
      newUrl = newUrl.replace(currentUrl, "")
      // console.log("currentUrl", newUrl)
      window.location.replace(newUrl)
    }
    // setIsReady(false)
    // fetchConfig()
  }, [])

  const { data: latest_version_data, isLoading: isLoadingLatestVersion, isRefetching } = FetchLatestVersion()

  return (
    <>
    <style>
      {`
      
      `}
    </style>
      <GoogleAnalytics />
      <EnvironmentIndicator />
      <ReloadPopup newVersion={latest_version_data} />
      <ThemeProvider theme={theme}>
        <ToastProvider>
          <ThemeRoutes />
        </ToastProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
